module.exports = __webpack_public_path__ + "static/undraw_online_organizer_ofxm-9cb7ac0cc641b5dc1be89bde9d41c458.svg";